/* tslint:disable */
/* eslint-disable */
/**
 * Bookingkit Api v4
 * Specification of Bookingkit Api v4
 *
 * The version of the OpenAPI document: 0.25.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { PaymentProviderActivation } from './payment-provider-activation';

/**
 * 
 * @export
 * @interface PaymentProvider
 */
export interface PaymentProvider {
    /**
     * 
     * @type {string}
     * @memberof PaymentProvider
     */
    'id': PaymentProviderIdEnum;
    /**
     * 
     * @type {string}
     * @memberof PaymentProvider
     */
    'status': PaymentProviderStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PaymentProvider
     */
    'kyc_status': PaymentProviderKycStatusEnum;
    /**
     * 
     * @type {PaymentProviderActivation}
     * @memberof PaymentProvider
     */
    'activation_intent'?: PaymentProviderActivation;
}

export const PaymentProviderIdEnum = {
    Stripe: 'STRIPE',
    Mangopay: 'MANGOPAY'
} as const;

export type PaymentProviderIdEnum = typeof PaymentProviderIdEnum[keyof typeof PaymentProviderIdEnum];
export const PaymentProviderStatusEnum = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE',
    Scheduled: 'SCHEDULED'
} as const;

export type PaymentProviderStatusEnum = typeof PaymentProviderStatusEnum[keyof typeof PaymentProviderStatusEnum];
export const PaymentProviderKycStatusEnum = {
    Verified: 'VERIFIED',
    Unverified: 'UNVERIFIED',
    Pending: 'PENDING',
    ActionRequired: 'ACTION_REQUIRED',
    Rejected: 'REJECTED'
} as const;

export type PaymentProviderKycStatusEnum = typeof PaymentProviderKycStatusEnum[keyof typeof PaymentProviderKycStatusEnum];


